import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import './InfoPage.css';

const DeleteAccountPage = () => {
  const navigate = useNavigate();
  return (
    <div className="info-page">
      <div className="info-header-wrap"><Header /></div>
      <div className="info-container">
        <button className="back-btn" onClick={() => navigate('/')}>← Back</button>
        <h1>Delete Account</h1>
        <p>This is a draft flow. To request account deletion:</p>
        <ol>
          <li>Send an email to delete@myhelpz.com with your registered phone number.</li>
          <li>We will verify ownership and confirm deletion within 7 days.</li>
          <li>All personal data will be removed as per our retention policy.</li>
        </ol>
        <p className="muted">In-app delete flow is coming soon.</p>
      </div>
      <Footer />
    </div>
  );
};

export default DeleteAccountPage;
